// Quote Context
import { useQuoteContext } from '../../hooks/useQuoteContext'
import Description from './Description'
import Spacer from './Spacer'
// Component Imports
// JS Imports
// Asset Imports

export default function DealDeskActive({
   order = -50,
   billingFreq = 'monthly',
}) {
   const state = useQuoteContext()
   const { getString } = state

   // Early returns for all conditions that should hide the banner
   if (state.user_view !== 'Internal') return null
   if (!state.dealDeskLocks || state.dealDeskLocks.size === 0) return null
   if (!state.product_list || Object.keys(state.product_list).length === 0)
      return null

   // Check if any locked product matches the billing frequency
   let hasMatch = false
   for (const productCode of state.dealDeskLocks) {
      const product = state.product_list[productCode]
      if (product && product.BillingFreq === billingFreq) {
         hasMatch = true
         break
      }
   }

   if (!hasMatch) return null

   return (
      <div className='row' style={{ order: order }}>
         <Description
            className='text-center col'
            title={getString('product.DealDeskActive.Hoverable.Text')}
            content={
               <>
                  <div className='row'>
                     <div className='col'>
                        <div
                           dangerouslySetInnerHTML={{
                              __html: getString(
                                 'product.DealDeskActive.Description.Content',
                              ),
                           }}
                        />
                     </div>
                  </div>
               </>
            }
         >
            <span className='hoverable text-center text-primary'>
               {getString('product.DealDeskActive.Hoverable.Text')}
            </span>
         </Description>
         <Spacer />
      </div>
   )
}
